import gql from 'graphql-tag'
import { famVideo } from 'src/graphql/fragments/Video'
import { QapaPage } from 'src/types/fam-graphql'

import { queryServiceCreator } from '../../../../helpers/GraphqlHelpers'

const query = gql`
  query getQapaPage {
    getQapaPage {
      cover_image
      cover_title
      intro_text
      intro_video {
        ...famVideo
      }
      intro_tip_and_push {
        tip_image
        tip_text
        push_image
        push_text
        push_cta_text
        push_cta_url
      }
      tips_title
      tips {
        type
        title
        image
        url
      }
    }
  }
  ${famVideo}
`

const transformer = ({ getQapaPage }: { getQapaPage: QapaPage }): any =>
  getQapaPage

export default queryServiceCreator(query, transformer)
